module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.478/img/asset-marketplace-themes-2x.png"